import { tryParseJSON } from './tryParseJSON';

export const extractDataFromHTML = (root: HTMLElement) => {
    const dataset = root?.dataset;
    return function getOrElse<TValue extends unknown>(key: string, defaultValue: TValue): TValue {
        const data = !!dataset ? dataset[key] : undefined;
        if (data !== undefined) {
            if (typeof defaultValue === 'number') {
                return +data as TValue;
            }

            if (typeof defaultValue === 'boolean') {
                return (data.toLowerCase() === 'true') as TValue;
            }

            if (typeof defaultValue === 'object') {
                return (tryParseJSON(data) as TValue) || defaultValue;
            }

            return data as TValue;
        }

        return defaultValue;
    };
};
